// Forked from payments-mfe src/services/plaid.service.ts (PLAT-2857).
// One deliberate change: init() takes the link token from the caller instead of self-fetching
// from payment-bff — a Collect session runs at security level High, and payment-bff's Plaid
// endpoints are gated at LowWithKycEntry and would 401. The token comes from request-bff's
// FinalizeCollectRequest response. Consolidation into client-hub-shared is deferred cleanup.
import type { PlaidLinkOnSuccessMetadata } from '@Types/plaid';

type PlaidSuccessCallback = (publicToken: string, metadata: PlaidLinkOnSuccessMetadata) => void;
type PlaidExitCallback = (err: any, metadata: any) => void;

declare global {
    interface Window {
        Plaid: any;
    }
}

export class PlaidService {
    private handler: any = null;
    private linkToken: string | null = null;

    public async init(linkToken: string): Promise<void> {
        this.linkToken = linkToken;
        await this.loadPlaidScript();
    }

    private async loadPlaidScript(): Promise<void> {
        if (window.Plaid) return;

        await new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Failed to load Plaid script'));
            document.head.appendChild(script);
        });
    }

    public openPlaidLink(
        onSuccess: PlaidSuccessCallback,
        onExit?: PlaidExitCallback
    ): void {
        if (!this.linkToken) {
            throw new Error('PlaidService not initialized. Call init() first.');
        }

        this.handler = window.Plaid.create({
            token: this.linkToken,
            onSuccess,
            onExit,
        });

        this.handler.open();
    }
}
